import React from 'react';
import { FiFilter } from 'react-icons/fi';

const FilterButton = ({ onClick, activeFiltersCount }) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <FiFilter className="mr-2 h-4 w-4" />
      Filters
      {activeFiltersCount > 0 && (
        <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
          {activeFiltersCount}
        </span>
      )}
    </button>
  );
};

export default FilterButton;
